import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  CircularProgress,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { customConfirmationPopupStyle } from "./style";
import closeIcon from "@assets/images/close.svg";

function CustomConfirmationPopup(props) {
  const classes = customConfirmationPopupStyle();
  const [scroll] = useState("body");
  return (
    <div className={classes.CustomConfirmationWrapper}>
      <Dialog
        open={props.open}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <div className="close-modal">
          {props?.hideCloseIcon ? <></> : 
          (
            <img 
            src={closeIcon} 
            alt="Close" 
            onClick={props.handleClose}
            style={props.disabled ? { pointerEvents: "none", opacity: 0.5, cursor: "default" } : { cursor: "pointer"}}
          />
          )}
        </div>
        {props.error && <Alert severity="error">{props.error}</Alert>}
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="primary-btn gray-border-btn"
            style={props.disabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
            disabled={props.disabled || false}
          >
            {props.loadingCancel ? (
                <CircularProgress color="inherit"/>
              ) :
              (<>{props.closeMessageBtn}</>)
            }
          </Button>
          <Button
            onClick={props.handleConfirm}
            color="primary"
            className="orange-btn primary-btn"
            disabled={props.disabled || false}
          >
            {props.loading ? (
                <CircularProgress color="inherit"/>
              ) :
              (<>{props.confirmMessageBtn}</>)
            }
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CustomConfirmationPopup;
